import { Colors } from "@brg/ui";
import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction : row;
    /* color: ${Colors}; */
    background-color: #E1E1E1;
    border-radius: 28px;
    padding: 4px;
    margin-top: 24px;
`
export const ButtonsContainer = styled.div<{active: boolean}>`
    padding: 13px 8px 8px 8px;
    width: 100%;
    border-radius: 24px;
    background-color: ${({active}) => active && '#F4F4F5'};
    box-shadow: ${({active}) => active ? '0 0 8px 0 rgba(0, 0, 0, 0.16)' : 'none'};
`

export const Title = styled.div`
    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        cursor: pointer;
    }
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
`

export const Button = styled.button`
    /* padding: 24px 13.2% 24px 13.2%; */
    /* justify-content: center;
    display: flex;
    padding: 20px 0; */
    padding: 20px 8px 20px 16px;
    background-color: #FFFFFF;
    border-radius: 16px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.16);
    gap: 8px;
    &:hover {
        cursor: pointer;
    }
    &:focus {
        outline: none !important;
        border: none !important;
    }
    border: none;
   
`
export const ButtonsWrapper = styled.div`
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const ButtonsWrapperNew = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const ButtonContent = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    & svg {
        min-width: fit-content;
    }
`
export const ButtonTitle = styled.div`
    display: block;
    text-align: start;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: -0.28px;    
    color: #212121;
`
export const TitleMain = styled.div`
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; 
    letter-spacing: -0.56px;
    color: #212121;
`

export const SubTitleMain = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.26px;
    color: #212121;
`

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const HeaderNew = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-self: flex-start;
    padding: 0 10px;
`

export const Wrapper = styled.div`
    padding: 16px 16px 0 16px;
    width: 100%;
`

export const WrapperNew = styled.div`
    padding-top: 16px;
    width: 100%;
`

export const ButtonsContainerNew = styled.div<{active: boolean}>`
    padding: 24px 10px 16px 10px;
    width: 100%;
`

export const ButtonNew = styled.button`
    padding: 16px;
    background-color: #FFFFFF;
    gap: 8px;
    &:hover {
        cursor: pointer;
    }
    &:focus {
        outline: none !important;
        border: none !important;
    }
    border: none;
`

export const ButtonContentNew = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: start;
    & svg {
        min-width: fit-content;
    }
    .content_wrapper {
        display: flex;
        gap: 8px;
    }
`
export const ButtonContentTextNew = styled.div`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: ${Colors.galBlack47};
    text-align: left;
`

export const ButtonTitleNew = styled.div`
    display: block;
    text-align: start;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    display: flex;
    align-items: center;  
    color: ${Colors.zel};
`

export const TitleMainNew = styled.div`
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.56px;
    color: #212121;
    
`

export const SubTitleMainNew = styled.div`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: #212121;
`import { Colors } from "@brg/ui";
import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction : row;
    /* color: ${Colors}; */
    background-color: #E1E1E1;
    border-radius: 28px;
    padding: 4px;
    margin-top: 24px;
`
export const ButtonsContainer = styled.div<{active: boolean}>`
    padding: 13px 8px 8px 8px;
    width: 100%;
    border-radius: 24px;
    background-color: ${({active}) => active && '#F4F4F5'};
    box-shadow: ${({active}) => active ? '0 0 8px 0 rgba(0, 0, 0, 0.16)' : 'none'};
`

export const Title = styled.div`
    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        cursor: pointer;
    }
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
`

export const Button = styled.button`
    /* padding: 24px 13.2% 24px 13.2%; */
    /* justify-content: center;
    display: flex;
    padding: 20px 0; */
    padding: 20px 8px 20px 16px;
    background-color: #FFFFFF;
    border-radius: 16px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.16);
    gap: 8px;
    &:hover {
        cursor: pointer;
    }
    &:focus {
        outline: none !important;
        border: none !important;
    }
    border: none;
   
`
export const ButtonsWrapper = styled.div`
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const ButtonsWrapperNew = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const ButtonContent = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    & svg {
        min-width: fit-content;
    }
`
export const ButtonTitle = styled.div`
    display: block;
    text-align: start;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: -0.28px;    
    color: #212121;
`
export const TitleMain = styled.div`
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; 
    letter-spacing: -0.56px;
    color: #212121;
`

export const SubTitleMain = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.26px;
    color: #212121;
`

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const HeaderNew = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-self: flex-start;
    padding: 0 10px;
`

export const Wrapper = styled.div`
    padding: 16px 16px 0 16px;
    width: 100%;
`

export const WrapperNew = styled.div`
    padding-top: 16px;
    width: 100%;
`

export const ButtonsContainerNew = styled.div<{active: boolean}>`
    padding: 24px 10px 16px 10px;
    width: 100%;
`

export const ButtonNew = styled.button`
    padding: 16px;
    background-color: #FFFFFF;
    gap: 8px;
    &:hover {
        cursor: pointer;
    }
    &:focus {
        outline: none !important;
        border: none !important;
    }
    border: none;
`

export const ButtonContentNew = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: start;
    & svg {
        min-width: fit-content;
    }
    .content_wrapper {
        display: flex;
        gap: 8px;
    }
`
export const ButtonContentTextNew = styled.div`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: ${Colors.galBlack47};
    text-align: left;
`

export const ButtonTitleNew = styled.div`
    display: block;
    text-align: start;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    display: flex;
    align-items: center;  
    color: ${Colors.zel};
`

export const TitleMainNew = styled.div`
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.56px;
    color: #212121;
    
`

export const SubTitleMainNew = styled.div`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: #212121;
`